module.exports = __webpack_public_path__ + "static/media/drop-pin-icon.fba1a8ad.svg";